export enum GameActivityType {
  Match = 'match',
  Tournament = 'tournament',
}
